// removed by extract-text-webpack-plugin
module.exports = {"theme":"#45baa3"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/reset.scss
// module id = ulDn
// module chunks = 6